import React, { Component } from "react";
import Select from 'react-select';
// Usar react-date-range (compatible con React 17)
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import 'moment/locale/es';
import '../styles/datepicker-override.css';
import '../styles/pagination-override.css';
import ReactPaginate from 'react-paginate';
import { LangContext } from "../LangContext.jsx";

moment.locale('es');
class ReportsInvitations extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            invitations: [],
            currentPage: 0,
            itemsPerPage: 10,
            totalPages: 0,
            showFrom: 0,
            showTo: 0,
            totalInvitations: 0,
            showExport: true,
            showRut: false,
            selectedId: null,
            selectedName: null,
            selectedRfc: null,
            selectedEmail: null,
            selectedRelation: null,
            selectedType: null,
            selectedTemplate: null,
            selectedStatus: null,
            idOptions: [],
            nameOptions: [],
            rfcOptions: [],
            emailOptions: [],
            templateOptions: [],
            relationOptions: [
                {value: "Proveedor", label: "Proveedor"},
                {value: "Empleado", label: "Empleado"},
                {value: "Cliente", label: "Cliente"},
            ],
            typeOptions: [
                {value: "Especiales", label: "Especiales"},
                {value: "Nacional", label: "Nacional"},
            ],
            statusOptions: [
                {value: "Invitado", label: "Invitado"},
                {value: "Declinado", label: "Declinado"},
            ],
            showAdvancedFilters: false,
            focusedInput: null,
            startDate: null,
            endDate: null,
            showCreatedPicker: false,
            params : {
                invitation:{
                    id: null,
                    name: null,
                    rfc: null,
                    email: null,
                    status: null,
                    relation: null,
                    type: null,
                    template: null,
                    created_at: null,
                },
                sort:{
                    order: null,
                    column: null
                },
                page: 0,
                limit:  10,
            },
        };
        this.createdPickerRef = React.createRef();
    }

    getInvitations(){
        const { currentPage, itemsPerPage } = this.state;
        axios.get('/api/reports/invitations', {
                params: {
                    ...this.state.params,
                    page: currentPage +1,
                    limit: itemsPerPage
                }
            }).then(res=>{
                const invitations = res.data.data;

                this.setState({
                    invitations,
                    showFrom: res.data.from,
                    showTo: res.data.to,
                    totalInvitations: res.data.total,
                    totalPages: Math.ceil(res.data.total / itemsPerPage)
                });
        })
        this.getFilters();
    }

    getFilters() {
        axios.get('/api/filters/invitations', {
            params: {
                ...this.state.params,
            }
        }).then((res) => {
            const invitationFilters = res.data;

            this.setState({
            nameOptions: invitationFilters.nameOptions,
            rfcOptions: invitationFilters.rfcOptions,
            idOptions: invitationFilters.idOptions,
            emailOptions: invitationFilters.emailOptions,
            templateOptions: invitationFilters.templateOptions,
            });
        });
    }

    exportReports() {
        const ids = this.state.idOptions.map(item => {
            const id = item.value.split('-')[1];
            return id;
        });
        const dataJSON = JSON.stringify(ids);

        axios.post('/api/export/invitations', {
            data: dataJSON,
        }, {
            responseType: 'blob',
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            const fileName = 'ReporteInvitaciones.xls';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        });
    }

    componentDidMount() {
        this.getInvitations();
        document.addEventListener('mousedown', this.handleClickOutside);
    };

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleIdChange = (event) => {
        let value = (event) ? event.value.split('I-')[1] : null;

        const updatedParams = {
            ...this.state.params,
            invitation: {
                ...this.state.params.invitation,
                id: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedId: event,
        }, this.getInvitations);
    }

    handleRfcChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            invitation: {
                ...this.state.params.invitation,
                rfc: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedRfc: event,
        }, this.getInvitations);
    }

    handleNameChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            invitation: {
                ...this.state.params.invitation,
                name: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedName: event,
        }, this.getInvitations);
    }

    handleEmailChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            invitation: {
                ...this.state.params.invitation,
                email: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedEmail: event,
        }, this.getInvitations);
    }

    handleRelationChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            invitation: {
                ...this.state.params.invitation,
                relation: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedRelation: event,
        }, this.getInvitations);
    }

    handleTypeChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            invitation: {
                ...this.state.params.invitation,
                type: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedType: event,
        }, this.getInvitations);
    }

    handleTemplateChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            invitation: {
                ...this.state.params.invitation,
                template: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedTemplate: event,
        }, this.getInvitations);
    }

    handleStatusChange = (event)=>{
        const value = event ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            invitation: {
                ...this.state.params.invitation,
                status: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedStatus: event,
        }, this.getInvitations);
    }

    handleDateChange = (ranges) => {
        const sel = ranges.selection || {};
        const startDate = sel.startDate || null;
        const endDate = sel.endDate || null;
        const startStr = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endStr = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        const updatedParams = {
            ...this.state.params,
            invitation: {
                ...this.state.params.invitation,
                created_at: { startDate: startStr, endDate: endStr }
            }
        };

        this.resetCurrentPage();
        this.setState({
            startDate: startStr,
            endDate: endStr,
            params: updatedParams
        }, this.getInvitations);
    }

    toggleCreatedPicker = () => this.setState(prev => ({ showCreatedPicker: !prev.showCreatedPicker }));
    handleClickOutside = (e) => {
        if (this.state.showCreatedPicker && this.createdPickerRef.current && !this.createdPickerRef.current.contains(e.target)) {
            this.setState({ showCreatedPicker: false });
        }
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        this.setState({ currentPage: selected }, this.getInvitations);
    }

    handleItemsPerPageChange = (event) => {
        const newItemsPerPage = parseInt(event.target.value, 10);
        this.setState({
            itemsPerPage: newItemsPerPage,
            currentPage: 0
        }, this.getInvitations);
    };

    resetCurrentPage = () => {
        this.setState({
            currentPage: 0,
        });
    }

    clearDates = () => {
        const updatedParams = {
            ...this.state.params,
            invitation: {
                ...this.state.params.invitation,
                created_at: null
            }
        };

        this.setState({
            params: updatedParams,
            startDate: null,
            endDate: null
        }, this.getInvitations);
    }

    clearFilters = () => {
        this.setState({
            selectedId: null,
            selectedName: null,
            selectedRfc: null,
            selectedEmail: null,
            selectedRelation: null,
            selectedType: null,
            selectedTemplate: null,
            selectedStatus: null,
            startDate: null,
            endDate: null,
            params : {
                invitation:{
                    id: null,
                    name: null,
                    rfc: null,
                    email: null,
                    status: null,
                    relation: null,
                    type: null,
                    template: null,
                },
                sort:{
                    order: null,
                    column: null
                },
            },
        }, this.getInvitations);
    };

    handleSort = (column) => {
        this.setState(prevState => {
            if (column === prevState.params.sort.column) {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: prevState.params.sort.order === 'asc' ? 'desc' : 'asc'
                        }
                    }
                };
            } else {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: 'asc'
                        }
                    }
                };
            }
        }, this.getInvitations);
    };

    toggleAdvancedFilters = () => {
        this.setState(prevState => ({
            showAdvancedFilters: !prevState.showAdvancedFilters
        }));
    };

    render() {
        const { lang } = this.context; 
      return (
        <>
            <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <div>
                        <h5 className="text-dark font-weight-bold my-1 mr-5">
                            {lang.get('messages.reporte_de_invitaciones')} ({lang.get('messages.invitados')})
                        </h5>
                        <p className="text-dark-50 font-weight-bold my-1 mr-5">
                            <span className="text-primary datatable-count">{this.state.totalInvitations}</span> {lang.get('messages.invitaciones_enviadas')}.
                        </p>
                    </div>
                    <div className="d-flex align-items-center flex-wrap">
                        {this.state.showExport &&
                            <a
                                id="export"
                                className="btn btn-primary px-10 font-weight-bolder"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.exportReports();
                                }}
                                >{lang.get('messages.exportar')}</a>
                        }
                    </div>
                </div>
            </div>
            
            <div className="container">
                <div className="datatable-filters">
                    <div className="d-flex justify-content-between mb-4">
                        <div className="font-weight-bolder">{lang.get('messages.filtrar_por')}:</div>
                        <a
                            className="datatable-clear-filters float-right text-primary"
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.clearFilters();
                            }}
                        ><strong>{lang.get('messages.limpiar_todos_los_filtros')}</strong></a>
                    </div>

                    <div className="d-flex justify-content-between mb-4 default">
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">Id</label>
                            <Select
                                value={this.state.selectedId}
                                onChange={this.handleIdChange}
                                options={this.state.idOptions}
                                placeholder={<div>Buscar por Id</div>}
                                isClearable={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.nombre')}</label>
                            <Select
                                value={this.state.selectedName}
                                onChange={this.handleNameChange}
                                options={this.state.nameOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_nombre')}</div>}
                                isClearable={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">RFC</label>
                            <Select
                                value={this.state.selectedRfc}
                                onChange={this.handleRfcChange}
                                options={this.state.rfcOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_rfc')}</div>}
                                isClearable={true}
                            />
                        </div>
                    </div>
                    {this.state.showAdvancedFilters && (
                        <div className="advanced-filters">
                            <div className="d-flex justify-content-between mb-4 default">
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.correo')}</label>
                                    <Select
                                        value={this.state.selectedEmail}
                                        onChange={this.handleEmailChange}
                                        options={this.state.emailOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_email')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.relacion')}</label>
                                    <Select
                                        value={this.state.selectedRelation}
                                        onChange={this.handleRelationChange}
                                        options={this.state.relationOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_relacion')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.tipo')}</label>
                                    <Select
                                        value={this.state.selectedType}
                                        onChange={this.handleTypeChange}
                                        options={this.state.typeOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_tipo')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-4 default">
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.plantilla_de_expediente')}</label>
                                    <Select
                                        value={this.state.selectedTemplate}
                                        onChange={this.handleTemplateChange}
                                        options={this.state.templateOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_plantilla')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.estatus')}</label>
                                    <Select
                                        value={this.state.selectedStatus}
                                        onChange={this.handleStatusChange}
                                        options={this.state.statusOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_estatus')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="datepicker-container">
                                        <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.fecha_de_creacion')}</label><br></br>
                                        <div style={{ position: 'relative' }}>
                                            <div
                                                className="form-control d-flex align-items-center justify-content-between"
                                                style={{ cursor: 'pointer' }}
                                                onClick={this.toggleCreatedPicker}
                                            >
                                                <span>{this.state.startDate ? moment(this.state.startDate).format('ll') : lang.get('messages.fecha_inicio')}</span>
                                                <span className="mx-2">–</span>
                                                <span>{this.state.endDate ? moment(this.state.endDate).format('ll') : lang.get('messages.fecha_fin')}</span>
                                                {(this.state.startDate || this.state.endDate) && (
                                                    <span onClick={(e) => { e.stopPropagation(); this.clearDates(); }} style={{ marginLeft: 'auto' }}>
                                                        <i className="flaticon2-delete text-muted"></i>
                                                    </span>
                                                )}
                                            </div>

                                            {this.state.showCreatedPicker && (
                                                <div ref={this.createdPickerRef} className="date-range-popover">
                                                    <DateRange
                                                        ranges={[{
                                                            startDate: this.state.startDate ? new Date(this.state.startDate) : new Date(),
                                                            endDate: this.state.endDate ? new Date(this.state.endDate) : new Date(),
                                                            key: 'selection'
                                                        }]}
                                                        onChange={this.handleDateChange}
                                                        editableDateInputs={true}
                                                        moveRangeOnFirstSelection={false}
                                                        months={1}
                                                        direction="horizontal"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {this.state.showAdvancedFilters == false &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-down mr-2"></span> {lang.get('messages.mostrar_filtros_avanzados')}
                            </a>
                        </div>
                    }
                    {this.state.showAdvancedFilters == true &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-up mr-2"></span> {lang.get('messages.ocultar_filtros_avanzados')}
                            </a>
                        </div>
                    }
                </div>
                <div className="table-responsive">
                    <table className="table table-report w-100" id="datatable">
                        <thead>
                            <tr>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('id')}>
                                    Id
                                    {this.state.params.sort.column === 'id' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '200px' }} onClick={() => this.handleSort('name')}>
                                    {lang.get('messages.nombre')}
                                    {this.state.params.sort.column === 'name' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('rfc')}>
                                    {this.state.showRut ? 'RUT' : 'RFC'}
                                    {this.state.params.sort.column === 'rfc' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '200px' }} onClick={() => this.handleSort('email')}>
                                    {lang.get('messages.correo')}
                                    {this.state.params.sort.column === 'email' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('relation')}>
                                    {lang.get('messages.relacion')}
                                    {this.state.params.sort.column === 'relation' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('type')}>
                                    {lang.get('messages.tipo')}
                                    {this.state.params.sort.column === 'type' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '250px' }} onClick={() => this.handleSort('template')}>
                                    {lang.get('messages.plantilla_de_expediente')}
                                    {this.state.params.sort.column === 'template' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '100px' }} onClick={() => this.handleSort('status')}>
                                    {lang.get('messages.estatus')}
                                    {this.state.params.sort.column === 'status' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{width: '150px'}} onClick={() => this.handleSort('created_at')}>
                                    {lang.get('messages.fecha_invitacion')}
                                    {this.state.params.sort.column === 'created_at' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.invitations.map((invitation) => (
                                <tr key={invitation.id} id={invitation.id}>
                                    <td className="text-dark-75 font-weight-bolder">{`I-${invitation.id}`}</td>
                                    <td className="text-dark-75 font-weight-bolder">{invitation.name}</td>
                                    <td className="text-dark-50 font-weight-bold">{invitation.rfc}</td>
                                    <td className="text-dark-50 font-weight-bold">{invitation.email}</td>
                                    <td className="text-dark-75 font-weight-bolder">
                                        {lang.get('messages.'+invitation.dossier_target_name.toLowerCase())}
                                    </td>
                                    <td className="text-dark-50 font-weight-bolder">
                                        {lang.get('messages.'+invitation.dossier_type_title.toLowerCase())}
                                    </td>
                                    <td className="text-dark-50 font-weight-bold my-1 mr-5">
                                        {invitation.dossier_title}
                                    </td>
                                    <td>{invitation.status}</td>
                                    <td className="text-dark-50 font-weight-bold my-1 mr-5"
                                        data-sort={invitation.created_at === '' ? '' : new Date(invitation.created_at).toISOString().slice(0,10)}>
                                        {invitation.created_at === '' ? '' : new Date(invitation.created_at).toLocaleDateString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between">
                        <div className="col mt-2 px-0">
                            {lang.get('messages.mostrando_del')} {this.state.showFrom} {lang.get('messages.al')} {this.state.showTo} {lang.get('messages.de')} {this.state.totalInvitations} {lang.get('messages.registros')}.
                        </div>
                        <div className="row">
                            <div className="d-flex justify-content-between">
                                <p className="mr-2 mt-2">
                                    {lang.get('messages.mostrar')}:
                                </p>
                                <select
                                    value={this.state.itemsPerPage}
                                    onChange={this.handleItemsPerPageChange}
                                    aria-controls="datatable"
                                    className="custom-select custom-select-sm form-control form-control-sm"
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>
                            </div>
                            <ReactPaginate
                                previousLabel={'< ' + lang.get('messages.anterior')}  
                                nextLabel={ lang.get('messages.siguiente') + ' >'} 
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.totalPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                activeClassName={'active'}
                                previousClassName={'previous'}
                                nextClassName={'next'}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
      );
    }
}

export default ReportsInvitations;
